var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{red: _vm.red, mini: _vm.mini},attrs:{"disabled":_vm.disabled},on:{"click":_vm.click}},[_vm._v(_vm._s(_vm.label))])}
var staticRenderFns = []

export { render, staticRenderFns }